module.exports = __webpack_public_path__ + "static/media/Nursery_0.1c4ee641.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/nursery/Nursery_0.png
// module id = 1279
// module chunks = 3